import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../features/auth/authSlice';
import logo from '../assets/xtrafyls.svg';
import { signin_profile } from '../assets';
import verificationProgressIcon from '../assets/verification_progress.svg';
import '../components/VerificationInProgress.css';

const VerificationInProgress = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBackToSignIn = () => {
    dispatch(logout());
    navigate('/signin');
  };

  return (
    <div className="verification-progress-container">
      {/* Left Side - Purple Section */}
      <div className="verification-progress-left">
        <div className="left-content">
          <img src={logo} alt="Xtrafyl" className="logo" />

          <div className="hero-section">
            <h1 className="hero-title">
              Fuel Your Business<br />
              With <span className="highlight">Xtrafyl.</span>
            </h1>
            <p className="hero-description text-big-body">
              From fuel delivery to charging, car wash, and more — we help you reach
              more customers, every day.
            </p>
          </div>
        </div>
      </div>

      {/* Right Side - Verification Card */}
      <div className="verification-progress-right">
        <div className="verification-card">
          {/* Icon */}
          <div className="verification-icon">
            <img src={verificationProgressIcon} alt="Verification in Progress" />
          </div>

          {/* Content */}
          <h2 className="verification-title">Verification in Progress</h2>
          <p className="verification-message">
            Your documents have been submitted and are currently under review.
            <br />
            This usually takes 24–48 hours.
            <br />
            We'll notify you as soon as your account is approved.
          </p>

          {/* Back to Sign In Button */}
          <button
            className="back-to-signin-button"
            onClick={handleBackToSignIn}
          >
            BACK TO SIGN IN
          </button>

          {/* Footer Note */}
          <p className="verification-footer">
            You'll be able to access the dashboard once verification is complete.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationInProgress;
